import { useCallback } from "react";
import ForkDashboardDialog from "../components/ForkDashboardDialog";

export default function useDuplicateDashboard(dashboard) {
  const duplicateDashboard = useCallback(() => {
    ForkDashboardDialog.showModal({ dashboard });
  }, [dashboard]);

  return duplicateDashboard;
}
